// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1342":"afed01e5a59cf782","4066":"afed01e5a59cf782","5857":"c2e02cbcae6293ac"}[chunkId] + ".css";
};